module.exports = __webpack_public_path__ + "img/spongebob-price-chart-coinmarketcap.57680e27.webp";